export default __webpack_public_path__ + "static/media/help-drawer-header-1x.764f6a6c.png";